import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./NasaPod.css";

const API_BASE = process.env.NODE_ENV === "development"
  ? "https://arecah.com/nasapod/api"
  : "/nasapod/api";

function NasaPod() {
  const [date, setDate] = useState(() => {
    const d = new Date();
    return d.toISOString().split("T")[0];
  });
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchApod = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await fetch(`${API_BASE}/nasa-api.php?date=${date}`);
        const json = await res.json();
        if (json.error) {
          setError(json.error);
          setData(null);
        } else {
          setData(json);
        }
      } catch (err) {
        setError(err.message || "Failed to fetch");
        setData(null);
      } finally {
        setLoading(false);
      }
    };
    fetchApod();
  }, [date]);

  return (
    <div className="nasapod">
      <Link to="/" className="nasapod-back-link">← Arecah</Link>

      {loading && <div className="nasapod-loading">Loading…</div>}
      {error && <div className="nasapod-error">{error}</div>}

      {data && !loading && (
        <>
          <div className={`nasapod-image-container ${data.media_type === "video" ? "nasapod-video-container" : ""}`}>
            {data.media_type === "image" ? (
              <img src={data.url} alt={data.title} />
            ) : (
              <iframe
                title={data.title}
                src={data.url}
                className="apod-video"
                allowFullScreen
              />
            )}
          </div>

          <div className="nasapod-overlay">
            <div className="nasapod-overlay-inner">
              <h1>{data.title}</h1>
              <p className="nasapod-date">{data.date}</p>
              <div className="nasapod-date-picker-wrap">
                <input
                  type="date"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  className="nasapod-date-picker"
                />
              </div>
              <p className="nasapod-explanation">{data.explanation}</p>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default NasaPod;
